/**
 * @description Gestion des fontions communes aux pages du site
 */

(() => {
  // FONCTIONS
  // Savoir quand la page est chargée
  const loaded = () => {
    document.addEventListener('DOMContentLoaded', () => {
      document.body.classList.add('loaded');
      bsBreakpoints.init();
    });
  };

  const deleteEmpty = html => {
    document.querySelectorAll(html).forEach(el => {
      const content = el.innerText;
      if (content === null || content === undefined || content === '') {
        el.remove();
      }
    });
  };
  const adaptativeFooter = () => {
    const h = window.innerHeight;
    const main = document.querySelector('main');
    const footerHeight = document.querySelector('.footer').offsetHeight -.5;
    const headerHeight = document.querySelector('.header').offsetHeight;
    const sum = footerHeight + headerHeight;
    if(main.offsetHeight < h){
      main.setAttribute(
        "style", "position:relative; min-height:calc(100vh - "+sum+"px);"
      )
    }
  }

  // GO 🚀
  const init = () => {
    loaded();
    deleteEmpty('p');
    deleteEmpty('li');
    adaptativeFooter();
  };

  init();
})();
